import { GQL } from '@aline/graphql';

import type { UUID } from '../../../types/type-helpers';
import type { AlineText, InputFieldElementInterface } from '../../internal';

export const signatureFieldVariant: GQL.FieldVariant.Signature = GQL.FieldVariant.Signature;

export interface SignatureFieldElement extends InputFieldElementInterface {
  children: AlineText[];
  variant: GQL.FieldVariant.Signature;
  imgHeightPx?: number | null;
  imgWidthPx?: number | null;
  signatureImgId?: UUID | null;
}
export type SignatureFieldProps = Omit<SignatureFieldElement, 'children'>;
